import { ComponentStyleConfig } from '@chakra-ui/react';
import type { StyleFunctionProps } from '@chakra-ui/theme-tools';

import { TagProps } from './Tag';

import { FONT_WEIGHTS } from 'theme/Typography';

const TagTheme: ComponentStyleConfig = {
  baseStyle: (props: TagProps & StyleFunctionProps) => {
    const { bg, color } = props;
    return {
      textAlign: 'center',
      fontWeight: FONT_WEIGHTS.medium,
      container: {
        _light: {
          backgroundColor: bg || 'silver.light',
          color: color || 'black.lighter'
        },
        _dark: {
          backgroundColor: bg || 'black.lighter',
          color: color || 'silver.lighter'
        }
      }
    };
  },
  sizes: {
    md: {
      container: {
        borderRadius: 4,
        padding: '0 6px'
      }
    }
  },
  defaultProps: {
    colorScheme: undefined
  }
};

export default TagTheme;
